import httpGet from "./httpget";
import httpPost from "./httppost";
const domain = "https://webpdfapi.foxitcloud.cn";

// 获取用户信息
export const getUserInfo = (config = {}) =>
  httpGet({
    url: config.params.token
      ? `${domain}/getUserInfo?plateform=wechatmp`
      : `${domain}/getUserInfo?`,
    config
  });

// IAM 使用code 获取 token
export const getIAMToken = (config = {}) =>
  httpPost({
    url: `${domain}/createIamToken`,
    params: config.params,
    config
  });

// 退出
export const IamLogout = (config = {}) =>
  httpGet({
    url: `${domain}/iamLogout`,
    params: config.params,
    config
  });